import { IconSize, IconColorKeys } from "@izettle/otto"

import { SvgIcon, IconMetadata } from "../svg-icon"

export type IconProps<TSize extends IconSize> = {
  svgIcon?: IconMetadata<TSize>
  color?: IconColorKeys
  title?: string
  block?: boolean
  alt?: string
  transform?: { x?: string; y?: string }
  nonStandardSizeOverride?: IconSize
  className?: string
}

export function Icon<TSize extends IconSize>({
  svgIcon,
  transform,
  color,
  block,
  alt,
  nonStandardSizeOverride,
  className,
  ...props
}: IconProps<TSize>) {
  return svgIcon ? (
    <SvgIcon<TSize>
      {...props}
      className={className}
      icon={svgIcon}
      transform={transform}
      color={color}
      block={block}
      alt={alt}
      nonStandardSizeOverride={nonStandardSizeOverride}
    />
  ) : null
}
